module.exports = __webpack_public_path__ + "img/ECNP2PGNJ.dece2546.svg";